RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.AdsLoadingView = Marionette.ItemView.mixin({
        template: '#adsLoadingTemplate',

        ui: {
            adsLoading: '.x-ads-loading',
            adsLoaded: '.x-ads-loaded'
        },

        events: {
            'click .reload-link': 'onReload'
        },

        modelEvents: {
            'change': 'onLoadStatusChanged'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        onLoadStatusChanged: function () {
            const me = this;

            if (!me.model.get('isLoadingAds')) {
                // ask for a reload if:
                // - we were loading in the past but aren't any longer.
                // - we found new ad accounts and we're done loading them.
                if (me.model.previous('isLoadingAds') || me.model.get('newAdAccountsFound')) {
                    me.showReloadLink = true;
                }
            }

            me.render();
        },

        onRender: function () {
            const me = this;

            if (me.showReloadLink) {
                me.ui.adsLoaded.show();
                me.ui.adsLoading.hide();
            } else if (me.model.get('isLoadingAds')) {
                me.ui.adsLoading.show();
                me.ui.adsLoaded.hide();
            }
        },

        onReload: function () {
            const me = this;

            RivalIQ.state.landscape.invalidateCaches();
            me.dashboardModel.reload();
        },

        onDestroy: function () {
            const me = this;

            me.model.stopPolling();
        }
    });
});
